import { render, staticRenderFns } from "./UploadShopFiles.vue?vue&type=template&id=48f67764&scoped=true&"
import script from "./UploadShopFiles.vue?vue&type=script&lang=js&"
export * from "./UploadShopFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadShopFiles.vue?vue&type=style&index=0&id=48f67764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f67764",
  null
  
)

component.options.__file = "UploadShopFiles.vue"
export default component.exports